



























































































































import { pIntegerPass } from "@/utils/rules";
import {
  createIntegralGoodsData,
  createIntegralGoodsApi,
  getIntegralGoodsDetailApi,
  editIntegralGoodsData,
  editIntegralGoodsApi,
  deleteIntegralGoodsApi,
} from "@/api/integral";
import richTextEditor from "@/components/richTextEditor.vue";
import imageUploader from "@/components/imageUploader.vue";
import previewDialog from "./previewDialog.vue";
import stockDialog from "./stockDialog.vue";
import { Vue, Component } from "vue-property-decorator";
@Component({
  name: "integralGoodsDetail",
  components: {
    imageUploader,
    richTextEditor,
    previewDialog,
    stockDialog,
  },
})
export default class extends Vue {
  mainForm: any = {
    description: "",
  };
  rules: any = {
    goods_name: [
      { required: true, message: "请填写商品名称", trigger: "blur" },
    ],
    cover_image: [
      { required: true, message: "请选择显示封面", trigger: "change" },
    ],
    stock: [{ required: true, message: "请填写库存", trigger: "blur" }],
    integral: [{ required: true, message: "请填写积分", trigger: "blur" }],
    status: [],
    sort: [{ validator: pIntegerPass, trigger: "blur" }],
    remark: [],
    description: [],
  };
  created() {
    this.getDetail();
  }
  getDetail() {
    const id = Number(this.$route.query.id);
    if (id !== 0) {
      // 编辑
      getIntegralGoodsDetailApi({ goods_id: id }).then((res: any) => {
        res.data.status = res.data.status === 1;
        this.mainForm = res.data;
      });
    }
  }
  handleSubmit() {
    (this.$refs["mainForm"] as Vue & { validate: Function }).validate(
      (valid: boolean) => {
        if (valid) {
          const id = Number(this.$route.query.id);
          if (id) {
            const option: editIntegralGoodsData = {
              goods_id: this.mainForm.goods_id,
              goods_name: this.mainForm.goods_name,
              cover_image: this.mainForm.cover_image,
              stock: this.mainForm.stock,
              integral: this.mainForm.integral,
              status: this.mainForm.status ? 1 : 2,
            };
            if (this.mainForm.sort) {
              option.sort = this.mainForm.sort;
            }
            if (this.mainForm.remark) {
              option.remark = this.mainForm.remark;
            }
            if (this.mainForm.description) {
              option.description = this.mainForm.description;
            }
            editIntegralGoodsApi(option).then(() => {
              this.$message({
                type: "success",
                message: "编辑成功!",
              });
              this.$router.push({
                name: "integralGoods",
              });
            });
          } else {
            const option: createIntegralGoodsData = {
              goods_name: this.mainForm.goods_name,
              cover_image: this.mainForm.cover_image,
              stock: this.mainForm.stock,
              integral: this.mainForm.integral,
              status: this.mainForm.status ? 1 : 2,
            };
            if (this.mainForm.sort) {
              option.sort = this.mainForm.sort;
            }
            if (this.mainForm.remark) {
              option.remark = this.mainForm.remark;
            }
            if (this.mainForm.description) {
              option.description = this.mainForm.description;
            }
            createIntegralGoodsApi(option).then(() => {
              this.$message({
                type: "success",
                message: "新增成功!",
              });
              this.$router.push({
                name: "integralGoods",
              });
            });
          }
        }
      }
    );
  }
  handleDelete() {
    this.$confirm(
      "删除后，用户无法再兑换，旧兑换信息需要手动取消。确定要删除商品？",
      `删除 - ${this.mainForm.goods_name}`,
      {
        confirmButtonText: "确定",
        confirmButtonClass: "mwow-button-filled success mini",
        cancelButtonText: "取消",
        cancelButtonClass: "mwow-button-filled mini",
        iconClass: "mwow-icon-error",
      }
    )
      .then(() => {
        deleteIntegralGoodsApi({ goods_id: this.mainForm.goods_id }).then(
          () => {
            this.$message({
              type: "success",
              message: "删除成功!",
            });
            this.$router.go(-1);
          }
        );
      })
      .catch(() => {});
  }
}
